<template>
  <section class="max-w-6xl mx-auto px-4 py-12">
    <!-- Image & Title -->

    <h1 class="text-4xl font-bold mb-4">The Moment That Moved Us</h1>
    <div class="flex flex-col md:flex-row items-center gap-8 mb-12">
      <img
        src="@/assets/Our_Journey.png"
        alt="Founder talking to rag picker"
        class="w-full md:w-1/2 rounded-xl shadow-lg"
      />
      <div class="text-center md:text-left">
        
        <p>It all began in 2009 with a simple, haunting question:<br />
          <strong><em>“Why does clean air feel like a luxury?”</em></strong></p>
          <p>
            In a world already filling up with smart devices—phones that recognized faces, televisions that responded to touch—
            it struck our founder that something as vital as <strong>breathing clean air</strong> was still being overlooked.
          </p>

          <p>
            That evening, walking home through a dusty road, he instinctively lifted a handkerchief to shield himself from the pollution in the air.
            But just a few steps ahead, something brought him to a stop.
          </p>

          <p>
            A ragpicker was working—bent over a pile of waste, sifting through it without gloves, without a mask, without even a cloth
            to protect himself from the choking air.
          </p>

          <p>
            The founder, moved by the sight, said gently:<br />
            <em>“You should cover your nose while working.”</em>
          </p>

          <blockquote>
            <p>“If we cover our faces, people think we’re thieves.”</p>
          </blockquote>

          <p>
            That simple sentence shook something inside him.
          </p>

          <p>
            It wasn’t just about air anymore.<br />
            It was about <strong>dignity</strong>.<br />
            About how even self-protection could be misjudged—especially when it came from someone invisible to the world.
          </p>

          <p>
            From that moment on, the idea took root:
          </p>

          <p><strong>What if protection could be invisible, dignified, and accessible?</strong></p>

          <p>
            He began developing discreet nose filters, applying for patents, and experimenting with early-stage materials.
            Over time, that vision expanded into smart, affordable air purifiers, and even nanofiber filtration systems —
            all designed with one core belief:
          </p>

          <p><strong><em>Everyone deserves to breathe clean air — without judgment, without compromise.</em></strong></p>

          <p>
            That belief became <strong>Shvason</strong>.
          </p>
      </div>
    </div>

    <!-- Mission, Vision, Values -->
    <div class="grid md:grid-cols-3 gap-8 text-center md:text-left">
      <div>
        <h2 class="text-2xl font-semibold mb-2">🎯 Mission</h2>
        <p>
          To empower people to breathe cleaner air every day by delivering reliable, affordable,
          and technologically advanced purification solutions.
        </p>
      </div>
      <div>
        <h2 class="text-2xl font-semibold mb-2">🌍 Vision</h2>
        <p>
          To make clean and healthy air accessible to every household by building solutions designed
          in India, for India—solutions that respect both affordability and dignity.
        </p>
      </div>
      <div>
        <h2 class="text-2xl font-semibold mb-2">💡 Innovation with Empathy</h2>
        <p>
          We blend smart engineering with empathy, building products that don't just solve problems, but genuinely care for the people who use them.
        </p>
      </div>
    </div>

  </section>

  <section class="max-w-4xl mx-auto px-4 py-12 text-gray-800">
  <h2 class="text-3xl font-bold mb-6">Our Milestones</h2>
  <p>
    Since 2009, Shvason has grown from a spark of empathy into a journey of relentless innovation — with multiple patents filed across discreet nose filters, smart air purification systems, and nanofiber fabrication technologies, each milestone reflecting our commitment to make clean air accessible, dignified, and rooted in real human need.
  </p>
  </section>

  <section class="max-w-4xl mx-auto px-4 py-10 text-gray-800">
  <h2 class="text-3xl font-bold mb-6">Why Shvason </h2>
  <p>
    At Shvason, we're not just building devices — we're rethinking what it means to protect air and dignity at the same time.
    Our work is rooted in solving real, everyday problems faced by real people — from ragpickers in landfill zones to families in dusty towns.
    We don’t design for labs. We design for life — with empathy, affordability, and purpose at every step.
  </p>
</section>

</template>

<script>
export default {
  name: 'AboutUs'
}
</script>

<style scoped>
</style>
